// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { AiSuggestion_Kgv2NodeResolvedFragment, CommonAiSuggestion_WithKgv2Fragment } from '../../aiSuggestions/graphql/aiSuggestions.fragments.generated';
import { CommonAiSuggestionEvidenceFragment, ReferenceAiOnboardingSuggestionFragment } from '../../aiSuggestions/graphql/aiSuggestions.generated';
import { gql } from '@apollo/client';
import { AiSuggestion_Kgv2NodeResolvedFragmentDoc, CommonAiSuggestion_WithKgv2FragmentDoc } from '../../aiSuggestions/graphql/aiSuggestions.fragments.generated';
import { CommonAiSuggestionEvidenceFragmentDoc, ReferenceAiOnboardingSuggestionFragmentDoc } from '../../aiSuggestions/graphql/aiSuggestions.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AiSuggestion_DispositiveProvisionFragment = (
  { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null, dpDeathEvent?: Types.AiSuggestionDispositiveProvisionDeathEvent | null, dpFirstDeathGrantorClientProfile?: { __typename?: 'ClientProfile', id: string } | null, dpRecipient?: (
    { __typename?: 'DispositiveProvisionRecipientSuggestion' }
    & DpRecipientSuggestionFragment
  ) | null, dpRecipientKgV2Nodes: { __typename?: 'KGV2NodeConnection', edges?: Array<{ __typename?: 'KGV2NodeEdge', node?: (
        { __typename?: 'KGV2Node' }
        & AiSuggestion_Kgv2NodeResolvedFragment
      ) | null } | null> | null }, evidence?: Array<(
    { __typename?: 'AISuggestionEvidence' }
    & CommonAiSuggestionEvidenceFragment
  )> | null, entity?: { __typename?: 'Entity', id: string } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string } | null, referenceAiOnboardingSuggestion?: (
    { __typename?: 'AISuggestion' }
    & ReferenceAiOnboardingSuggestionFragment
  ) | null }
  & CommonAiSuggestion_WithKgv2Fragment
);

export type DpRecipientSuggestionFragment = { __typename?: 'DispositiveProvisionRecipientSuggestion', dispositionKind?: Types.DispositiveProvisionDispositionKind | null, dispositionOrder?: number | null, distributionAmount?: string | null, distributionPercentage?: string | null, dispositionFormulaicPercentage?: string | null, dispositionLimit?: string | null, growByInflation?: boolean | null, notes?: string | null, recipientEntityName?: string | null, recipientID?: string | null, recipientKind?: Types.DispositiveProvisionRecipientKind | null, recipientOrganizationName?: string | null, recipientTransferTaxKind?: Types.DispositiveProvisionTransferTaxKind | null, distributionDeathEvent?: string | null, recipientNameParts?: { __typename?: 'PersonNameParts', firstName: string, lastName: string, middleName: string, suffix: string } | null };

export type DismissAidpSuggestionsMutationVariables = Types.Exact<{
  acknowledgeSuggestionsInput: Array<Types.AcknowledgeAiSuggestionInput> | Types.AcknowledgeAiSuggestionInput;
}>;


export type DismissAidpSuggestionsMutation = { __typename?: 'Mutation', acknowledgeAISuggestions: Array<{ __typename?: 'AISuggestion', id: string, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null }> };

export const Operations = {
  Mutation: {
    DismissAIDPSuggestions: 'DismissAIDPSuggestions' as const
  },
  Fragment: {
    AISuggestion_DispositiveProvision: 'AISuggestion_DispositiveProvision' as const,
    DPRecipientSuggestion: 'DPRecipientSuggestion' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const DpRecipientSuggestionFragmentDoc = gql`
    fragment DPRecipientSuggestion on DispositiveProvisionRecipientSuggestion {
  dispositionKind
  dispositionOrder
  distributionAmount
  distributionPercentage
  dispositionFormulaicPercentage
  dispositionLimit
  growByInflation
  notes
  recipientEntityName
  recipientID
  recipientKind
  recipientNameParts {
    firstName
    lastName
    middleName
    suffix
  }
  recipientOrganizationName
  recipientTransferTaxKind
  distributionDeathEvent
}
    `;
export const AiSuggestion_DispositiveProvisionFragmentDoc = gql`
    fragment AISuggestion_DispositiveProvision on AISuggestion {
  id
  kind
  acceptanceStatus
  dpDeathEvent
  dpFirstDeathGrantorClientProfile {
    id
  }
  dpRecipient {
    ...DPRecipientSuggestion
  }
  dpRecipientKgV2Nodes(first: 1) {
    edges {
      node {
        ...AISuggestion_KGV2NodeResolved
      }
    }
  }
  evidence {
    ...CommonAISuggestionEvidence
  }
  entity {
    id
  }
  testamentaryEntity {
    id
  }
  referenceAiOnboardingSuggestion {
    ...ReferenceAIOnboardingSuggestion
  }
  ...CommonAISuggestion_WithKGV2
}
    ${DpRecipientSuggestionFragmentDoc}
${AiSuggestion_Kgv2NodeResolvedFragmentDoc}
${CommonAiSuggestionEvidenceFragmentDoc}
${ReferenceAiOnboardingSuggestionFragmentDoc}
${CommonAiSuggestion_WithKgv2FragmentDoc}`;
export const DismissAidpSuggestionsDocument = gql`
    mutation DismissAIDPSuggestions($acknowledgeSuggestionsInput: [AcknowledgeAISuggestionInput!]!) {
  acknowledgeAISuggestions(input: $acknowledgeSuggestionsInput) {
    id
    acceptanceStatus
  }
}
    `;
export type DismissAidpSuggestionsMutationFn = Apollo.MutationFunction<DismissAidpSuggestionsMutation, DismissAidpSuggestionsMutationVariables>;

/**
 * __useDismissAidpSuggestionsMutation__
 *
 * To run a mutation, you first call `useDismissAidpSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissAidpSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissAidpSuggestionsMutation, { data, loading, error }] = useDismissAidpSuggestionsMutation({
 *   variables: {
 *      acknowledgeSuggestionsInput: // value for 'acknowledgeSuggestionsInput'
 *   },
 * });
 */
export function useDismissAidpSuggestionsMutation(baseOptions?: Apollo.MutationHookOptions<DismissAidpSuggestionsMutation, DismissAidpSuggestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissAidpSuggestionsMutation, DismissAidpSuggestionsMutationVariables>(DismissAidpSuggestionsDocument, options);
      }
export type DismissAidpSuggestionsMutationHookResult = ReturnType<typeof useDismissAidpSuggestionsMutation>;
export type DismissAidpSuggestionsMutationResult = Apollo.MutationResult<DismissAidpSuggestionsMutation>;
export type DismissAidpSuggestionsMutationOptions = Apollo.BaseMutationOptions<DismissAidpSuggestionsMutation, DismissAidpSuggestionsMutationVariables>;